import InputQty from './InputQty'

export default InputQty
